export const ADD_IDP = 'organization/identityproviders/CREATE'
export const ADD_IDP_SUCCESS = `${ADD_IDP}_SUCCESS`

export const UPDATE_IDP = 'organization/identityproviders/UPDATE'
export const UPDATE_IDP_SUCCESS = `${UPDATE_IDP}_SUCCESS`

export const DELETE_IDP = 'organization/identityproviders/DELETE'
export const DELETE_IDP_SUCCESS = `${DELETE_IDP}_SUCCESS`

export const FETCH_SAML_IDP_CONFIG = 'organization/samlidp/FETCH'
export const FETCH_SAML_IDP_CONFIG_SUCCESS = `${FETCH_SAML_IDP_CONFIG}_SUCCESS`
